import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/discovery/updateGoal';
import { fetchRequest as fetchGoalDetail } from '../../actions/discovery/goalDetail';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(action) {
  try {
    const { goalId, fields } = action?.payload || {};
    const response = yield call(
      axios.patch,
      `${config.API_URL}/goals/${goalId}`,
      fields || {},
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess(response?.data?.data));
    // Reflect the saved settings immediately.
    yield put(fetchGoalDetail({ goalId }));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
